import { api } from "./client";

export interface Order {
  id: string;
  companyId: string;
  productId?: string;
  customerId?: string;
  amount: number;
  currency: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export const ordersApi = {
  list: (companyId: string) =>
    api.get<Order[]>(`/companies/${companyId}/orders`),
};
